// import React, { useEffect, useState } from 'react';
// import { Col, Container, Row , Form, Nav} from 'react-bootstrap';
// import './AdminLogin.css';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import TDD1 from '../Assets/milk.jpg';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';


// const AdminLogin = () => {
//   const navigate = useNavigate()

//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [isValid, setIsValid] = useState(true)
  
//   const handleEmail = (e) => {
//     setEmail(e.target.value)
//     setIsValid(true)
//     // Reset the logout timer on user activity
//     resetLogoutTimer();
//   }

//   const handlePassword = (e) => {
//     setPassword(e.target.value)
//     setIsValid(true)
//     // Reset the logout timer on user activity
//     resetLogoutTimer();
//   }

//   // Timer to automatically logout user after 5 minutes of inactivity
//   let logoutTimer;

//   const resetLogoutTimer = () => {
//     clearTimeout(logoutTimer);
//     logoutTimer = setTimeout(logout, 15 * 60 * 1000); // 5 minutes
//   };

//   const logout = () => {
//     // Clear user data from session storage and navigate to login page
//     sessionStorage.removeItem('userdata');
//     navigate('/');
//   };

//   useEffect(() => {
//     // Initialize the logout timer on component mount
//     resetLogoutTimer();

//     // Clear the logout timer on component unmount
//     return () => {
//       clearTimeout(logoutTimer);
//     };
//   }, []);
//   //======================================================================================================

//   const loginFun = async (e) => {
//     e.preventDefault()
//     if (email === '' || password === '') {
//       setIsValid(false)
//       return
//     }

//     const logObj = {
//       email: email,
//       password: password,
//     }
//     console.log("lkkjsdh",logObj)

//     try {
//       const response = await axios.post('http://192.168.29.112:9082/api/admin/login',logObj);

//       console.log("++++++",response)
//       if (response.data.userdata && response.data.userdata.length > 0) {
//         const userData = response.data.userdata[0];
  
//         // Store user data in session storage
//         sessionStorage.setItem('userdata', JSON.stringify(userData));
  
//         // Navigate to admin dashboard
//         navigate('/adminDashboard');
//       } else {
//         // Handle invalid login details
//         toast.error('Invalid login details!!', {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       // Handle server error
//       alert('Server Error');
//     }
//   };

//        //--------------- forgotpassword---------------------------//

//        const [forgetshow,setForgetshow]=useState()
//        const [forgetemail,setForgetemail]=useState()
//        const [phone,setPhone]=useState()
//        const handleforgetshow = () => {
//          setForgetshow(true)
//          // setLogshow(false)
//        };
//        const handleforgetClose = () => setForgetshow(false);
//        const handleEmailforChange = (e) => {
//          setForgetemail(e.target.value);
        
//        };
 
//        const handleforgetlog=(event)=>{
//          event.preventDefault();
//          const forgotdata={
//            email:forgetemail,
//            phone:phone
//          }
          
//        console.log("Email data",forgotdata);
//          axios.put('http://192.168.29.112:9082/api/userlogin/logii',forgotdata)
//          .then((res) => {
//              if (res.data.status === "SUCCESS") {
//                // alert("Your Password Has Been Sent On Email");
//                toast.success('Your Password Has Been Sent On Email', {
//                  position: "top-right",
//                  autoClose: 3000,
//                  hideProgressBar: false,
//                  closeOnClick: true,
//                  pauseOnHover: true,
//                  draggable: true,
//                });
//                setForgetshow(false)
//              } 
//              else if(res.data==="ERROR") {
//                // alert("Cheack Your Enter Emailid");
//                toast.error('Cheack Your Enter Emailid', {
//                  position: "top-right",
//                  autoClose: 3000,
//                  hideProgressBar: false,
//                  closeOnClick: true,
//                  pauseOnHover: true,
//                  draggable: true,
//                });
//                setForgetshow(false)
//              }
//              // else if(res.data==="FAILED"){
//              //   alert("Failed To Send Email");
//              //   setForgetshow(false)
               
//              // }
//              else {
//                toast.error('Server Error', {
//                  position: "top-right",
//                  autoClose: 3000,
//                  hideProgressBar: false,
//                  closeOnClick: true,
//                  pauseOnHover: true,
//                  draggable: true,
//                });
               
//              }
//            })
//            .catch((err) => {
//                // alert("Failed To Send Email, try again");
//                toast.error('Failed To Send Email, try again', {
//                  position: "top-right",
//                  autoClose: 3000,
//                  hideProgressBar: false,
//                  closeOnClick: true,
//                  pauseOnHover: true,
//                  draggable: true,
//                });
//                setForgetshow(false)
//              });
 
//  }


//   return (
//     <Container fluid>

//      <Row className='wrap' style={{display:"flex",justifyContent:"center",alignItems:"center"}}>

//       <Col sm={12} md={12} className='   align-item-center '>
//         <Col style={{ display: 'flex', justifyContent: 'center' }}>
//           <Col sm={12} md={12} style={{ backgroundColor:"transparent" }}>

//               <div className='login-container'>     
//          <div className='login-form'>
//             <form>
//                 <div className='input3'>
                    
//                     <h1 className='text-center pt-2 text-light'><i class="fa-solid fa-user fs-2" ></i> Login</h1>
//                     <input id='input3' type="Email" placeholder='Email Id' onChange={handleEmail} required/>

//                     <input id='input4' type="password" placeholder='Password' onChange={handlePassword} required/>

//                     {isValid ? null : (
//                   <Col
//                     style={{
//                       color: 'red',
//                       margin: '10px',
//                     }}
//                   >
//                     All fields are compulsory*
//                   </Col>
//                 )}
//                     <div className='login-button mb-2'>
//                     <button type="submit"  className='login-btn1' onClick={loginFun} >LOGIN</button>
//                     </div>

//                     <div  className='pt-3' style={{display:"flex",justifyContent:"end"}}>
//                     <Nav.Link   style={{color:"black"}} onClick={() => setForgetshow(true)}><small className='forgot'>Forgot Password?</small></Nav.Link>
//                    </div>

//                     <div>
//                     <h6 className='text-center pt-4' style={{color:"rgb(255, 0, 119)"}}>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
//                     </div>
//                 </div>
//             </form> 
//           </div>
//         </div>
            
//           </Col>
//         </Col>
//       </Col>
//       </Row>

//                      {/*//Forget PassWord Modal */}

//      <Modal show={forgetshow} onHide={handleforgetClose} animation={false}>
//         <Modal.Header className='p-0 px-3 py-1'  closeButton>
//           <Modal.Title style={{fontSize:"20px"}}>Fill Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form  onSubmit={handleforgetlog}>
//             <Row className="mb-3">
//               <Form.Group md="4" controlId="validationCustom01">
//                 <Form.Label>Enter Email</Form.Label>
//                 <Form.Control
//                   required
//                   type="Email"
//                   placeholder="Enter Email"
//                   onChange={handleEmailforChange}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   Enter Email Please
//                 </Form.Control.Feedback>
//               </Form.Group>
//               <Form.Group md="4" controlId="validationCustom01">
//                 <Form.Label className='mt-3'>Mobile No. </Form.Label>
//                 <Form.Control
//                     maxLength="10"
//                     inputMode="numeric"  
//                     title='Please enter 10 digit num.'
//                     type="tel"
//                     placeholder='Enter Mobile Num'
//                     id="mobileNumber"
//                     value={phone}
//                     onChange={(e) => {
//                       const numericValue = e.target.value.replace(/\D/g, "");
//                       setPhone(numericValue);
//                     }}
//                     required
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   Enter Mobile No
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Row>
//             <Button type="submit">Send Now</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default AdminLogin;






import React, { useEffect, useState } from 'react';
import { Col, Container, Row , Form, Nav} from 'react-bootstrap';
import './AdminLogin.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import TDD1 from '../Assets/milk.jpg';
import logo from '../Assets/logonew.png';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AdminLoginAPI, ForgotApi } from './API/Api';

const AdminLogin = () => {
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(true);
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isValid, setIsValid] = useState(true)
  const [loading, setLoading] = useState(false);
      const [languageSelect, setLanguageSelect] = useState(sessionStorage.getItem('selectedLanguage') || 'English');
      const [prevLanguage, setPrevLanguage] = useState(languageSelect);
    
      const handleLanguageChange = (e) => {
          const selectedLanguage = e.target.value;
          setLanguageSelect(selectedLanguage);
          sessionStorage.setItem('selectedLanguage', selectedLanguage);
      };
  
  const handleEmail = (e) => {
    setEmail(e.target.value)
    setIsValid(true)
    resetLogoutTimer();
  }

  useEffect(() => {
    sessionStorage.clear()
  }, []);

 

  const handlePassword = (e) => {
    setPassword(e.target.value)
    setIsValid(true)
    // Reset the logout timer on user activity
    resetLogoutTimer();
  }


  let logoutTimer; 

  const resetLogoutTimer = () => {
    clearTimeout(logoutTimer);
    logoutTimer = setTimeout(logout, 60 * 60 * 1000); 
  };

  const logout = () => {
    // Clear user data from session storage and navigate to login page
    sessionStorage.removeItem('userdata');
    navigate('/');
  };

  useEffect(() => {
    // Initialize the logout timer on component mount
    resetLogoutTimer();

    // Clear the logout timer on component unmount
    return () => {
      clearTimeout(logoutTimer);
    };
  }, []);
  //======================================================================================================
  

  const loginFun = async (e) => {
    e.preventDefault();
    if (email === '' || password === '' || languageSelect === '') {
      setIsValid(false);
      return;
    }

    const logObj = {
      email: email,
      password: password,
      flag: languageSelect === 'Marathi' ? 2 : 1
    }

    try {
      const response = await axios.post(AdminLoginAPI,logObj);
      if (response.data.userdata && response.data.userdata.length > 0) {
        const userData = response.data.userdata[0];
  
        // Store user data in session storage
        sessionStorage.setItem('userdata', JSON.stringify(userData));
  
        // Navigate to admin dashboard
        navigate('/adminDashboard1');
      } else {
        // Handle invalid login details
        toast.error('Invalid login details!!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error('Error:', error);
      // Handle server error
      alert('Server Error');
    }
  };

       //--------------- forgotpassword---------------------------//

       const [forgetshow,setForgetshow]=useState()
      const deliveryLogin =()=>{
        navigate('/deliveryLogin')
      }
       const [forgetemail,setForgetemail]=useState()
       const [phone,setPhone]=useState()
       const handleforgetshow = () => {
         setForgetshow(true)
         // setLogshow(false)
       };
       const handleforgetClose = () => setForgetshow(false);
       const handleEmailforChange = (e) => {
         setForgetemail(e.target.value);
        
       };
 
       const handleforgetlog=(event)=>{
         event.preventDefault();
         const forgotdata={
           email:forgetemail,
           phone:phone
         }
          
       console.log("Email data",forgotdata);
         axios.put(ForgotApi,forgotdata)
         .then((res) => {
             if (res.data.status === "SUCCESS") {
               // alert("Your Password Has Been Sent On Email");
               toast.success('Your Password Has Been Sent On Email', {
                 position: "top-right",
                 autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
               });
               setForgetshow(false)
             } 
             else if(res.data==="ERROR") {
               // alert("Cheack Your Enter Emailid");
               toast.error('Cheack Your Enter Emailid', {
                 position: "top-right",
                 autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
               });
               setForgetshow(false)
             }
             // else if(res.data==="FAILED"){
             //   alert("Failed To Send Email");
             //   setForgetshow(false)
               
             // }
             else {
               toast.error('Server Error', {
                 position: "top-right",
                 autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
               });
               
             }
           })
           .catch((err) => {
               // alert("Failed To Send Email, try again");
               toast.error('Failed To Send Email, try again', {
                 position: "top-right",
                 autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
               });
               setForgetshow(false)
             });
 
 }

  const toggleForm = () => {
    setIsLoginFormVisible(prevState => !prevState);
  };

  const textStyle = {
    fontFamily: "cursive",
    fontSize: "2rem",
    color: "#333",
    fontWeight: "normal",
    textDecoration: "underline",
    textAlign: "center",
    letterSpacing: "2px",
    lineHeight: "1.5",
    color:"",
    backgroundImage: "radial-gradient(white 1%, transparent 1%)",
    backgroundSize: "5px 5px",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)", // Adding a text shadow for the brushed effect
    // Add any additional styles here
  };
  return (
    <section className="user">
      <div className="user_options-container">
        <div className="user_options-text">

          <div className={isLoginFormVisible ? "user_options-registered" : "user_options-unregistered"}>
          <div style={{display:"flex",justifyContent:"center"}}><img src={logo} alt="Logo"  width={190} height={120} /></div>
            <h1  style={textStyle} className='pt-2'>Dairy Connect</h1>

          </div>
        </div>

        <div className="user_options-forms" id="user_options-forms">
     
            <div className="">
              <h2 className="forms_title">Login</h2>
              <form className="forms_form">
                <fieldset className="forms_fieldset">
                  <div className="forms_field">
                    <input type="email" placeholder="Email" className="forms_field-input" onChange={handleEmail} required autoFocus />
                  </div>
                  <div className="forms_field">
                    <input type="password" placeholder="Password" className="forms_field-input" onChange={handlePassword} required />
                  </div>
            

                <div>
      <FormControl variant="standard" style={{width:"100%"}}>
        <InputLabel id="demo-simple-select-standard-label">Select Language</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={languageSelect}
                    onChange={handleLanguageChange}
          label="Select Language"
          className='w-100'
        >
          <MenuItem value="">
          </MenuItem>
          <MenuItem value='English'>English</MenuItem>
          <MenuItem value='Marathi'>Marathi</MenuItem>
        </Select>
      </FormControl>
      </div>


                </fieldset>
                <div className="forms_buttons" style={{display:"flex",justifyContent:"space-between"}}>
                  <button type="button" onClick={deliveryLogin} style={{borderBottom:"1px solid"}}>Delivery Login</button>
                  <input type="submit" value="Log In" onClick={loginFun} className="forms_buttons-action" />
                </div>
              </form>
              
            </div>
            <div className='fixed-bottom ps-2 text-center'>
             <p ><i>Developed By TechnoAarv Solution </i></p>
            </div>
           
        
        </div>
      </div>

                           {/*//Forget PassWord Modal */}

     <Modal show={forgetshow} onHide={handleforgetClose} animation={false}>
        <Modal.Header className='p-0 px-3 py-1'  closeButton>
          <Modal.Title style={{fontSize:"20px"}}>Fill Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form  onSubmit={handleforgetlog}>
            <Row className="mb-3">
              <Form.Group md="4" controlId="validationCustom01">
                <Form.Label>Enter Email</Form.Label>
                <Form.Control
                  required
                  type="Email"
                  placeholder="Enter Email"
                  onChange={handleEmailforChange}
                />
                <Form.Control.Feedback type="invalid">
                  Enter Email Please
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group md="4" controlId="validationCustom01">
                <Form.Label className='mt-3'>Mobile No. </Form.Label>
                <Form.Control
                    maxLength="10"
                    inputMode="numeric"  
                    title='Please enter 10 digit num.'
                    type="tel"
                    placeholder='Enter Mobile Num'
                    id="mobileNumber"
                    value={phone}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, "");
                      setPhone(numericValue);
                    }}
                    required
                />
                <Form.Control.Feedback type="invalid">
                  Enter Mobile No
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Button type="submit">Send Now</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </section>
    

    
  );
};

export default AdminLogin;


